import { SxProps, Theme } from '@mui/material';
import React from 'react';

import { Location } from '_lib/api/apiTypes.shim';

import { MenuItem } from '_lib/components/MenuItem/MenuItem';
import { TextField } from '_lib/components/TextField/TextField';
import { Typography } from '_lib/components/Typography/Typography';
import { formatAddressTwoLine } from '_lib/utils/helpers';

import { FieldIssueProps } from '_lib/utils/validationErrorUtils';

interface LocationSelectClearableProps extends FieldIssueProps {
  onSetLocation: (location: Location | null) => void;
  location: Location | null;
  locations: Location[];
  disabled?: boolean;
  required?: boolean;
  sx?: SxProps<Theme>;
}

export const LocationSelectClearable = (props: LocationSelectClearableProps) => {
  const { onSetLocation, location, locations, disabled, required, issuePath, issues, sx } = props;

  return (
    <TextField
      sx={sx}
      fullWidth
      label='Location'
      required={required}
      disabled={disabled}
      value={location?.providerId || ''}
      defaultValue={''}
      select
      error={{
        issues,
        issuePath
      }}
      onChange={(e) => {
        if (e.target.value) {
          const location = locations.find((a) => a.providerId === e.target.value);
          onSetLocation(location || null);
        }
      }}>
      {locations.length > 0 && [
        <MenuItem key='empty' value='empty'>
          ---
        </MenuItem>,
        ...locations.map((location) => {
          return (
            <MenuItem key={location.providerId} value={location.providerId}>
              {
                <Typography
                  sx={{ whiteSpace: 'pre-line' }}
                  text={`${location.name}\n ${formatAddressTwoLine(location)}`}
                />
              }
            </MenuItem>
          );
        })
      ]}
      {locations.length === 0 && <MenuItem disabled>No Locations found.</MenuItem>}
    </TextField>
  );
};
